// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScaledHeading_wrapper__lzWp9","textContainer":"ScaledHeading_textContainer__jTLJg","text":"ScaledHeading_text__88f3_"};